import LoginPage from './Login';

const IndexPage = () => {
  return <LoginPage />;
};

export default IndexPage;
